module.exports = __webpack_public_path__ + "static/media/allianz.b6cf4f90.jpeg";